import styled from 'styled-components';
import { space, color, textAlign, fontSize, lineHeight } from 'styled-system';
import { ThemeInterface } from '../theme/ThemeInterface';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { theme } from '../theme';

type Props = StyledSystemProps & {
  pointer?: boolean;
  onClick?: any;
  fontSize?: string;
  lineHeight?: string;
};

const BodyText = styled.p<Props>`
  ${space};
  ${fontSize};
  ${color};
  ${textAlign};
  ${lineHeight}
  font-size: ${(props: ThemeInterface) => props.theme.fontSizes[0]};
  text-transform: ${(props: ThemeInterface) => props.textTransform || 'none'};
  &:hover {
    cursor: ${(props: ThemeInterface) => (props.pointer ? 'pointer' : 'default')};
  }
`;

export default BodyText;

BodyText.defaultProps = {
  color: theme.colors.charcoalGrey,
};



// WEBPACK FOOTER //
// ./src/typography/P.ts